export enum ImprovedCottonEnum {
  BETTER_COTTON = 'BETTER_COTTON',
  ORGANIC = 'ORGANIC',
  COTTON_WITH_STICKINESS = 'COTTON_WITH_STICKINESS',
}
